<div class="sidebar" [class.collapsed]="isCollapsed">
  <div class="sidebar-header">
    <div class="logo-container">
    <img src="../../assets/FinTechLogobyInit.svg" alt="Logo" class="logo"  />
    </div>
  <button class="toggle-button" (click)="isCollapsed = !isCollapsed">
    <span class="material-icons">menu</span>
  </button>
  </div>
 
  
  <div class="menu-section">
    <div class="menu-title">Information</div>
    <a routerLink="/home" routerLinkActive="active-menu" class="menu-item">
      <span class="material-icons">home</span>
      <span class="menu-text">General</span>
    </a>
  </div>
  
  <div class="menu-section">
    <div class="menu-title">Jobs</div>
    <a routerLink="/notebooks" routerLinkActive="active-menu" class="menu-item">
      <span class="material-icons"> receipt </span>
      <span class="menu-text">Notebooks</span>
    </a>
    <a routerLink="/pipelines" routerLinkActive="active-menu" class="menu-item">
      <span class="material-icons"> schema </span>
      <span class="menu-text">Pipelines</span>
    </a>
  </div>

  <div class="menu-section">
    <div class="menu-title">Management</div>
    <a routerLink="/users" routerLinkActive="active-menu" class="menu-item">
      <span class="material-icons">person</span>
      <span class="menu-text">Users</span>
    </a>
    
    <!-- <a routerLink="/periods" class="menu-item">
      <span class="material-icons">calendar_today</span>
      <span class="menu-text">Periods</span>
    </a>
    <a routerLink="/changeApproval" class="menu-item">
      <span class="material-icons">approval</span>
      <span class="menu-text">Change Approval</span>
    </a>
    <a routerLink="/manualAdjustments" class="menu-item">
      <span class="material-icons">edit</span>
      <span class="menu-text">Manual Adjustments</span>
    </a> -->
  </div>

  <div class="menu-section">
    <div class="menu-title">Dimensions</div>
    <a routerLink="/accountMapping" routerLinkActive="active-menu" class="menu-item">
      <span class="material-icons">account_balance</span>
      <span class="menu-text">Account Mapping</span>
    </a>
    <!-- <a routerLink="/profitbaseMapping" class="menu-item">
      <span class="material-icons">map</span>
      <span class="menu-text">Profitbase Mapping</span>
    </a> -->
  </div>

  <div class="menu-section">
    <div class="menu-title">Upload</div>
    <a routerLink="/kpis" routerLinkActive="active-menu" class="menu-item">
      <span class="material-icons">insights</span>
      <span class="menu-text">KPIs</span>
    </a>
    <!-- <a routerLink="/trialBalances" class="menu-item">
      <span class="material-icons">balance</span>
      <span class="menu-text">Trial Balances</span>
    </a>
    <a routerLink="/chartOfAccounts" class="menu-item">
      <span class="material-icons">list</span>
      <span class="menu-text">Chart of Accounts</span>
    </a> -->
  </div>
</div>
